import { formatCurrency } from '../../../helpers/formatters'
import { Blur } from '../Blur'
import Text from '../Text'
import styles from './EstimatedValueCurrencyDisplay.module.scss'

interface EstimatedValueCurrencyDisplayProps {
  homeValue: number
  shouldBlur: boolean
}

export const EstimatedValueCurrencyDisplay = ({
  homeValue,
  shouldBlur,
}: EstimatedValueCurrencyDisplayProps) => {
  return (
    <Text
      element='div'
      className={styles.homeValueText}
      variant='neutralCool'
      variantCount='900'
    >
      <Blur amount='lg' enabled={shouldBlur}>
        {formatCurrency(homeValue)}
      </Blur>
    </Text>
  )
}
